import styled from 'styled-components'

const DocumentElement = styled.textarea`
  height: 80%;
  width: calc(100% - 20px);
  padding: 10px;
`

export { DocumentElement }
